<template>
  <div v-if="order.agent_status === 'canceled'">
    <FormVueSelect 
      :searchable="false" 
      v-model="order.cancellation_reason" 
      max-height="200" 
      :options="cancellationReasons" 
      option-value="value"
      :label="$t('fields.cancellation_reason')" 
      :error="errors.cancellation_reason && $t('errors.cancellation_reason_required', {
        field: $t('fields.cancellation_reason'),
      })">
      <template v-slot:option="{ option }">
        <p class="tw-p-2 tw-rounded tw-text-xs tw-px-4">{{ $t(option.name) }}</p>
      </template>
    </FormVueSelect>

    <div v-if="order.cancellation_reason === 'other'" class="tw-mt-4">
      <FormField
        v-model="order.cancellation_notes"
        :label="$t('fields.cancellation_notes')"
        type="textarea"
        :error="errors.cancellation_notes && $t('errors.cancellation_notes_required', {
          field: $t('fields.cancellation_notes'),
        })"
      />
    </div>
  </div>
</template>

<script setup>
import FormVueSelect from "@/components/form/FormVueSelect";
import FormField from "@/components/form/FormField";
import { defineProps, defineEmits, computed, toRef } from 'vue';
import { useI18n } from "vue-i18n";

const i18n = useI18n();

// Static cancellation reasons as requested in the requirements
const cancellationReasons = computed(() => [
  { name: 'order-status.cancellation.price-issue', value: 'price-issue', label: i18n.t('order-status.cancellation.price-issue') },
  { name: 'order-status.cancellation.changed-mind', value: 'changed-mind', label: i18n.t('order-status.cancellation.changed-mind') },
  { name: 'order-status.cancellation.found-elsewhere', value: 'found-elsewhere', label: i18n.t('order-status.cancellation.found-elsewhere') },
  { name: 'order-status.cancellation.product-unavailable', value: 'product-unavailable', label: i18n.t('order-status.cancellation.product-unavailable') },
  { name: 'order-status.cancellation.delivery-time', value: 'delivery-time', label: i18n.t('order-status.cancellation.delivery-time') },
  { name: 'order-status.cancellation.shipping-cost', value: 'shipping-cost', label: i18n.t('order-status.cancellation.shipping-cost') },
  { name: 'order-status.cancellation.wrong-order', value: 'wrong-order', label: i18n.t('order-status.cancellation.wrong-order') },
  { name: 'order-status.cancellation.other', value: 'other', label: i18n.t('order-status.cancellation.other') }
]);

const props = defineProps(['order', 'errors']);
const emit = defineEmits(['update:order']);
const errors = toRef(props, 'errors');

const order = computed({
  get() {
    return props.order;
  },
  set(value) {
    emit('update:order', value);
  }
});
</script>

<style></style> 